import { get } from 'lodash';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import Input from '@shared/components/forms/inputs/input/input.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import { Activity } from '@activities/interfaces/activity';

@Component({
  name: 'bpc-generate-sessions-form',
  components: {
    'bpc-datepicker': Datepicker,
    'bpc-switch': Switch,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class GenerateSessionsForm extends Vue {
  // PROPS
  @Prop(Object) entity;
  @Prop({ type: Object, default: null }) readonly activity: Activity;
  @Prop(Boolean) disabledFields: boolean;
  @Prop(Object) errors;
  @Prop({ type: Boolean, default: false }) readonly isBulk: boolean;
  @Prop(Number) readonly activity_id: number;
  @Prop(Number) readonly activity_group_id: number;
  @Prop({ type: String, default: '' }) readonly default_start_date: string;
  @Prop({ type: String, default: '' }) readonly default_end_date: string;

  // DATA
  // TODO: make interface
  public formModel: any = {
    group_ids: null,
    start_date: null,
    end_date: null,
    add_team_members_as_attendees: false,
  };

  public permissionEntityNameToUse: string = 'activities';

  public labelInputAttributes = {
    for: 'global__',
    cols: 12,
  };

  public errorCustom: AnyEntity = {};

  // COMPUTED
  get activityHasTeam(): boolean {
    return this.entity?.activity?.team_id || this.activity?.team_id;
  }

  // METHODS

  onCleanErrors(input) {
    this.errorCustom[input] = null;
  }

  // Format the recieved errors from backend and set it in the correct way for frontend
  setErrors() {
    if (this.errors) {
      this.errorCustom = Object.keys(this.errors).reduce((res, key) => {
        res[key] = this.errors[key][0] || null;
        return res;
      }, {});
    }
  }

  public cleanFormModel() {
    this.errorCustom = {};
    this.formModel.group_ids = null;
    this.formModel.start_date = null;
    this.formModel.end_date = null;
    this.formModel.add_team_members_as_attendees = false;
  }

  //  TODO: maybe to load start and end from activity.
  async initFormModel() {
    this.formModel.group_ids = [this.entity.id];
  }

  //LIFECYCLE
  mounted() {
    if (!this.isBulk) {
      if (
        this.entity?.activity?.activity_type === 'camp' ||
        this.entity?.activity?.activity_type === 'course'
      ) {
        this.formModel.start_date = this.entity.start_date || this.entity.start_date;
        this.formModel.end_date = this.entity.end_date || this.entity.end_date;
      } else {
        this.formModel.start_date = this.entity?.activity?.start_date || this.activity?.start_date;
        this.formModel.end_date = this.entity?.activity?.end_date || this.activity?.end_date;
      }
    }
  }

  destroy() {
    this.cleanFormModel();
  }

  // WATCHERS
  @Watch('errors', { immediate: true, deep: true })
  onErrorsChange() {
    this.setErrors();
  }

  @Watch('entity', { immediate: true, deep: true })
  onEntityChange() {
    this.initFormModel();
  }
}
